const { makeStyles } = require("@material-ui/core");

export const useStyles = makeStyles((theme) => ({
  input: {
    display: "none",
  },
  descStyle: {
    fontFamily: "Mulish",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "23px",
    color: "#0a0a29",
    padding: "16px 22px",
  },
  titleStyle: {
    fontFamily: "Mulish",
    fontStyle: "normal",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "23px",
    color: "#0a0a29",
    padding: "10px 22px",
    ...theme.borderBottom,
  },
  actions: {
    ...theme.borderTop,
    padding: "16px 22px",
  },
  imageBox: {
    width: "100%",
    height: "150px",
  },
}));
